import { useQuery } from 'react-query';

import { disciplineService } from 'corporate/services';

export const useGetDisciplines = () => {
  const { data, isError, isLoading, isFetching } = useQuery(
    ['disciplines'],
    ({ signal }) => disciplineService.getAllDisciplines(signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    records: data?.records ?? [],
    count: data?.count ?? 0,
    isError,
    isLoading,
    isFetching,
  };
};
